import { CrossIcon } from '../../../assets/icons';
import Button from '../../../components/Button';
import CustomModal from '../../../components/CustomModal';
import CustomModalContent from '../../../components/CustomModal/CustomModalContent';
import { Tab, TabBody, TabHeader, Tabs } from '../../../components/Tabs';
import useModalState from '../../../context/modal/useModalState';

import EditPosition from './EditPosition';
import TPSLContent from './TPSL/TPSLContent';

const EditPositionModal = () => {
    const { modalData, closeModal } = useModalState();

    const onClose = () => closeModal('editPositionModal');

    return (
        <CustomModal modalName='editPositionModal' className='edit-position-modal'>
            <Tabs defaultTab={modalData?.data?.defaultTab}>
                <TabHeader>
                    <Tab>Edit Position</Tab>
                    <Tab>TP/SL</Tab>
                </TabHeader>
                <Button variant='transparent' onClick={onClose}>
                    <CrossIcon />
                </Button>
                <TabBody>
                    <CustomModalContent className='edit-position-content'>
                        <EditPosition onClose={onClose} />
                    </CustomModalContent>
                    <CustomModalContent className='tpsl-content'>
                        <TPSLContent onClose={onClose} />
                    </CustomModalContent>
                </TabBody>
            </Tabs>
            {/* <CustomModalHeader title='Edit Position' onClose={onClose} /> */}
        </CustomModal>
    );
};

export default EditPositionModal;
